import { select, throttle } from "@fruugo/utilities";
import { DeviceWidth } from "../types";
import { minWidth } from "./utilities";

const pageBlackList = ["help", "account"];
let lastScrollTop = 0;

export function initStickyHeader() {
  const { pageType } = window;

  if (pageBlackList.some((p) => p === pageType)) return;

  minWidth(
    DeviceWidth.Medium,
    () => window.removeEventListener("scroll", throttledStickyHeader),
    () => window.addEventListener("scroll", throttledStickyHeader)
  );
}

const throttledStickyHeader = throttle(stickyHeader, 250);

function stickyHeader() {
  const currentScrollTop = document.documentElement.scrollTop;
  const header = select<HTMLDivElement>(".header");
  const buffer = 200;
  const stickyCssClass = "sticky";

  if (currentScrollTop > lastScrollTop) {
    header?.classList.remove(stickyCssClass);
  } else if (currentScrollTop < lastScrollTop - buffer) {
    if (!header?.classList.contains(stickyCssClass)) {
      header?.classList.add(stickyCssClass);
    }
  }
  lastScrollTop = currentScrollTop;
}
